import React from 'react';

import { TextAreaField, SelectField, ToggleSwitch, MCButton } from 'src/components/basic';
import { MediaDropBox } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';

import { lang, objectToSelectList, remCss } from 'src/helpers';

import LANG_CONST from 'src/helpers/lang/const';

const apiStateId = 'addFeedBack';

class AddFeedback extends BaseComponent {
  componentDidMount() {
    this.props.model.resetAddFeedback(this.props.feedback);
    this.props.model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    this.props.model.unsubscribe(this.subscription);
  }

  add = (e) => {
    e.preventDefault();
    const { hide } = this.props;
    this.props.model.addFeedback(() => {
      hide();
    });
  };

  render() {
    const { model, closeBtn, feedback } = this.props;
    const { handleChange, handleBlur } = model;
    const createState = model.getApiState(apiStateId);
    const { invalid, loading } = createState;

    return (
      <div className={'mc-popup-contain'} style={{ maxWidth: remCss(600) }}>
        <div className='mc-modal-header'>
          <div className='mc-popup-title'>
            {lang.t(feedback ? LANG_CONST.buttons.edit_feedback : LANG_CONST.buttons.add_feedback)}
          </div>
          {closeBtn}
        </div>
        <form className='mc-modal-body mc-flex-15-col' onSubmit={this.add}>
          <SelectField
            style={{ zIndex: 3 }}
            template={'6'}
            options={objectToSelectList(LANG_CONST.constants.health_statuses)}
            name={'status'}
            label={LANG_CONST.status}
            placeholder={'Health'}
            value={model.input('status')}
            onChange={(n, v) => {
              model.resetApiState(apiStateId);
              handleChange(n, v);
            }}
            invalid={invalid}
          />
          <div className={'mc-flex-col'}>
            <div className={'mc-flex'}>
              <div className={'mc-value-418 mc-grow'}>
                {lang.t(LANG_CONST.is_your_health_improved)}
              </div>
              <ToggleSwitch
                checked={model.state?.isImproved}
                onChange={() => handleChange('isImproved', !model.state?.isImproved)}
              />
            </div>
            <TextAreaField
              template={6}
              value={model.input('improvedComment')}
              onChange={(n, v) => {
                model.resetApiState(apiStateId);
                handleChange(n, v);
              }}
              onBlur={handleBlur}
              invalid={invalid}
              rows={5}
              name={'improvedComment'}
              placeholder={LANG_CONST.text.enter_word}
            />
          </div>
          <div className={'mc-flex-col'}>
            <div className={'mc-flex'}>
              <div className={'mc-value-418 mc-grow'}>{lang.t(LANG_CONST.side_effects)}</div>
              <ToggleSwitch
                checked={model.state?.isEffect}
                onChange={() => handleChange('isEffect', !model.state?.isEffect)}
              />
            </div>
            <TextAreaField
              template={6}
              value={model.input('effectComment')}
              onChange={(n, v) => {
                model.resetApiState(apiStateId);
                handleChange(n, v);
              }}
              onBlur={handleBlur}
              invalid={invalid}
              rows={5}
              name={'effectComment'}
              placeholder={LANG_CONST.text.enter_word}
            />
          </div>
          <div className={'mc-flex-col'}>
            <div className={'mc-value-418'}>{lang.t(LANG_CONST.media)}</div>
            <MediaDropBox
              template={3}
              name={'files'}
              labelIcon='Add File'
              multi={true}
              value={model.input('files') !== '' ? model.input('files') : []}
              media={model.input('media') || []}
              invalid={invalid}
              accept={{ 'image/*': [] }}
              onChange={(n, v) => {
                model.resetApiState(apiStateId);
                model.handleChange(n, v);
              }}
              onChangeMedia={(file, index) => {
                model.resetApiState(apiStateId);
                model.handleChange(
                  'media',
                  model.state.media.filter((item, i) => i !== index)
                );
              }}
            />
          </div>
        </form>
        <div className='mc-modal-footer mc-flex'>
          <div className='mc-grow' />
          <MCButton
            medium
            primary
            radius
            light
            disabled={loading}
            type={'button'}
            onClick={this.props.hide}
            label={LANG_CONST.buttons.cancel}
          />
          <MCButton
            medium
            primary
            radius
            dark
            disabled={loading}
            loading={loading}
            type={'submit'}
            onClick={this.add}
            label={lang.t(
              feedback ? LANG_CONST.buttons.edit_feedback : LANG_CONST.buttons.add_feedback
            )}
          />
        </div>
      </div>
    );
  }
}

export default AddFeedback;
